import _regenerator from "C:/Users/lptni/\u5F00\u53D1/dev/project/unbox-server/vue-admin/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "C:/Users/lptni/\u5F00\u53D1/dev/project/unbox-server/vue-admin/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.function.name.js";
import api from '@/api';
import util from '@/libs/util.js';
export default {
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  name: 'GiftEdit',
  data: function data() {
    return {
      sexs: [],
      downUrl: process.env.VUE_APP_DOWNLOAD_URL,
      imageUrl: '',
      uploadUrl: process.env.VUE_APP_API,
      uploadHeaders: {
        Authorization: util.cookies.get('token')
      },
      fileList: [],
      title: '',
      giftSexEnums: [],
      form: {
        giftId: null,
        sex: '',
        name: '',
        price: null,
        code: '',
        image: '',
        deliveryNum: null,
        operatorUserId: null,
        createTime: null
      },
      rules: {
        giftId: [{
          required: true,
          message: '请输入主键',
          trigger: 'blur'
        }],
        sex: [{
          required: true,
          message: '请输入用户性别',
          trigger: 'blur'
        }],
        name: [{
          required: true,
          message: '请输入礼物名称',
          trigger: 'blur'
        }],
        price: [{
          required: true,
          message: '请输入礼物价值',
          trigger: 'blur'
        }],
        code: [{
          required: true,
          message: '请输入礼物编号',
          trigger: 'blur'
        }],
        image: [{
          required: true,
          message: '请输入礼物图片',
          trigger: 'blur'
        }],
        deliveryNum: [{
          required: true,
          message: '请输入投递数',
          trigger: 'blur'
        }],
        operatorUserId: [{
          required: true,
          message: '请输入创建人',
          trigger: 'blur'
        }],
        createTime: [{
          required: true,
          message: '请输入创建时间',
          trigger: 'blur'
        }]
      }
    };
  },
  methods: {
    handleAvatarSuccess: function handleAvatarSuccess(res, file) {
      this.imageUrl = this.downUrl + '/' + res.body.url;
      this.form.image = res.body.url;
    },
    beforeAvatarUpload: function beforeAvatarUpload(file) {
      var isLt2M = file.size / 1024 / 1024 < 10;
      if (!isLt2M) {
        this.$message.error('上传文件不能超过 10MB!');
      }
      return isLt2M;
    },
    getGiftSexEnums: function getGiftSexEnums() {
      var _this = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var res;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _context.n = 1;
              return api.GET_ENUMERATION_LIST({
                name: 'xxxx'
              });
            case 1:
              res = _context.v;
              _this.giftSexEnums = res.body;
            case 2:
              return _context.a(2);
          }
        }, _callee);
      }))();
    },
    initEunmData: function initEunmData() {
      var thiz = this;
      this.enums.sexEnums(function (data) {
        thiz.sexs = data.body;
      });
    },
    setTitle: function setTitle(title) {
      this.title = title;
    },
    initData: function initData() {
      if (this.$refs.form !== undefined) {
        this.$refs.form.resetFields();
      }
      this.initEunmData();
      this.form.giftId = null;
      this.form.sex = null;
      this.form.name = null;
      this.form.price = null;
      this.form.code = null;
      this.form.image = null;
      this.form.deliveryNum = null;
      this.form.operatorUserId = null;
      this.form.createTime = null;
      this.imageUrl = null;
    },
    setData: function setData(data) {
      if (this.$refs.form !== undefined) {
        this.$refs.form.resetFields();
      }
      this.initEunmData();
      this.form.giftId = data.giftId + '';
      this.form.sex = data.sex;
      this.form.name = data.name;
      this.form.price = data.price + '';
      this.form.code = data.code;
      this.form.image = data.image;
      this.imageUrl = this.downUrl + '/' + data.image;
      this.form.deliveryNum = data.deliveryNum + '';
      this.form.operatorUserId = data.operatorUserId + '';
      this.form.createTime = data.createTime + '';
    },
    updateApi: function updateApi() {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              _context2.n = 1;
              return api.UPDATE_GIFT(_this2.form);
            case 1:
              _this2.$emit('initTableData');
              _this2.$message.success('操作成功');
              _this2.handleClose();
            case 2:
              return _context2.a(2);
          }
        }, _callee2);
      }))();
    },
    saveApi: function saveApi() {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              _context3.n = 1;
              return api.SAVE_GIFT(_this3.form);
            case 1:
              _this3.$emit('initTableData');
              _this3.$message.success('操作成功');
              _this3.handleClose();
            case 2:
              return _context3.a(2);
          }
        }, _callee3);
      }))();
    },
    save: function save() {
      var _this4 = this;
      this.$refs.form.validate(function (valid) {
        if (valid) {
          if (_this4.form.giftId != null) {
            _this4.$confirm('此操作将永久修改该数据, 是否继续?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(function () {
              _this4.updateApi();
            }).catch(function () {
              _this4.$message({
                type: 'info',
                message: '已取消修改'
              });
            });
          } else {
            _this4.saveApi();
          }
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    handleClose: function handleClose(done) {
      this.$emit('close');
    }
  }
};